<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="processType.pkid ? '编辑' : '新建'"
    width="600px"
    @close="$reset('form')"
  >
    <el-form ref="form" :model="processType" :rules="ruleValidate" class="form" label-width="80px">
      <el-form-item label="类型编号" prop="processTypeNo">
        <el-input v-model="processType.processTypeNo" placeholder="请输入类型编号" clearable />
      </el-form-item>
      <el-form-item label="类型名称" prop="processTypeName">
        <el-input v-model="processType.processTypeName" placeholder="请输入类型名称" clearable />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      processType: {
        processTypeName: "",
        processTypeNo: "",
      },
      ruleValidate: {
        processTypeNo: { required: true, message: "请输入类型编号", trigger: "blur" },
        processTypeName: { required: true, message: "请输入类型名称", trigger: "blur" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.processType = Object.assign(this.processType, row);
      }
    },

    // 提交
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "rtProcessTypes", this.processType)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                if (this.processType.pkid) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
